import React from 'react';
import clsx from 'clsx';

import { Icon } from '../Icon/Icon';

import styles from './SliderArrow.module.scss';

export type BaseProps = {
  className?: string;
  onClick?: () => void;
};

const Base: React.FC<BaseProps> = ({ children, onClick, className }) => (
  <div className={clsx(styles.root, className)} onClick={onClick}>
    {children}
  </div>
);

const Next: React.FC<any> = ({ onClick, className, ...args }) => (
  <Base onClick={onClick} className={className}>
    {args.currentSlide + args.slidesToShow < args.slideCount && <Icon name="arrow-right" />}
  </Base>
);

const Prev: React.FC<any> = ({ onClick, className, ...args }) => (
  <Base onClick={onClick} className={className}>
    {args.currentSlide > 0 && <Icon name="arrow-left" />}
  </Base>
);

export const SliderArrow = {
  Next,
  Prev,
};

export const SliderArrowNext = Next
export const SliderArrowPrev = Prev